import mainCaller from './mainCaller';

export async function createPoint(data, token) {
  return await mainCaller(`admin/createPoint`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function createPointIntro(data, token) {
  return await mainCaller(`admin/create/StoreIntro`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getFacilityList(token) {
  return await mainCaller(`admin/getAllFacilityList`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getPointByManagerId(token, id) {
  return await mainCaller(`admin/getPointByManagerId/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
export async function getPointById(id, token, branchId) {
  return await mainCaller(`admin/api/v1/members/${id}/addition-info?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getPointsBytUserId(id, token) {
  return await mainCaller(`admin/user/points/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
// export async function getAllPoints(token) {
//   return await mainCaller(`user/getAllPointsAdmin`, 'GET', null, {
//     Authorization: `Bearer ${token}`,
//   });
// }

export async function getHeadBranchs(token) {
  return await mainCaller(`admin/api/v1/search-options/head-branches`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getPointCategoriesByUserId(token, id) {
  return await mainCaller(`admin/getCategoryPoint/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
// 같은 본사 산하 직영점 목록 (#73 수강권 다지점 공유 — 지점 계정도 본사 직영점 전체 수신)
export async function getDirectBranches(token, branchId) {
  return await mainCaller(`admin/api/v1/search-options/direct-branches?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
export async function getHeadBranchId(token, id) {
  return await mainCaller(`admin/api/v1/search-options/branches?headBranchId=${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
export async function getAllBranchOption(token, id) {
  return await mainCaller(`admin/api/v1/search-options/all/branches?headBranchId=${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function deletePointCategoryId(token, id) {
  return await mainCaller(`admin/api/v1/branches/products/categories/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updatePointCategoryById(token, id, data) {
  return await mainCaller(`admin/api/v1/branches/products/categories/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function createPointCategoryByUserId(branchId, token, data) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/products/categories`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

// products

export async function getPointProductsByPointId(token, id, query) {
  const url = query ? `admin/getAllProductPoint/${id}?${query}` : `admin/getAllProductPoint/${id}`;
  return await mainCaller(url, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getBranchProductsById(token, id, query) {
  const url = query ? `admin/api/v2/branches/${id}/products?${query}` : `admin/api/v2/branches/${id}/products`;
  return await mainCaller(url, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getBranchProductsByIdNoQuery(token, id) {
  return await mainCaller(`admin/api/v1/branches/${id}/products`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function createBranchProduct(data, branchId, token) {
  return await mainCaller(`admin/api/v2/branches/${branchId}/products`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateBranchProduct(data, productId, token) {
  return await mainCaller(`admin/api/v2/branches/products/${productId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updatePointProduct(token, data) {
  return await mainCaller(`admin/update/product`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function deleteProductById(token, id) {
  return await mainCaller(`admin/api/v1/branches/products/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateRoomPolicies(data, branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/policies`, 'PATCH', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateRoomName(data, roomId, token) {
  return await mainCaller(`admin/api/v1/branches/rooms/${roomId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function createPointRoom(data, branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/rooms`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}
// 강의실 유형 변경이 예정 수업에 미치는 영향 — 저장 전 확인창용
export async function getRoomSettingImpact(roomId, params, token) {
  const query = Object.entries(params)
    .filter(([, v]) => v !== null && v !== undefined && v !== '')
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&');
  return await mainCaller(`admin/api/v1/branches/rooms/${roomId}/impact${query ? `?${query}` : ''}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
// 지점 강의실 전체의 현재 설정 기준 영향 — 강의실 카드 뱃지용
export async function getBranchRoomImpacts(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/rooms/impact`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
export async function deletePointRoom(id, token) {
  return await mainCaller(`admin/api/v1/branches/rooms/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
}
export async function getAllPointRooms(id, token) {
  return await mainCaller(`admin/api/v1/search-options/branch-rooms?branchId=${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getBranchCategories(branchId, token) {
  return await mainCaller(`admin/api/v2/branches/${branchId}/products/categories`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}
